import * as apiUtils from "./apiUtils";
import Cookies from "universal-cookie";
const baseUrl = process.env.API_URL + "/Users/";
const enrollmentUrl = process.env.API_URL + "/Enrollment/";
const dateListUrl = process.env.API_URL + "/DataList/";

import { Monitech } from "../_helpers/BrandConstants";

const cookies = new Cookies();

export function validateEnrollment(code, brandIdentifier) {
  return apiUtils
    .get(
      `${enrollmentUrl}ValidateCode/` +
        code +
        `?BrandIdentifier=${brandIdentifier === Monitech ? "monitechiid" : brandIdentifier}`,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function validateMailer(code) {
  return apiUtils
    .get(`${enrollmentUrl}ValidateMailer/` + code)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function updateMailer(mailerObj) {
  return apiUtils
    .post(`${enrollmentUrl}UpdateMailer`, mailerObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function enrolleeRegister(enrolleeObj) {
  enrolleeObj = { ...enrolleeObj, webUserName: "ClientEnrollment" };
  return apiUtils
    .post(`${baseUrl}EnrolleeRegister`, enrolleeObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function refreshTokenWithRequest(token, refreshTokenValue) {
  return apiUtils
    .postWithToken(`${baseUrl}RefreshWithRequest`, token, {
      RefreshToken: refreshTokenValue,
    })
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function verifyEmail(emailObj) {
  return apiUtils
    .post(`${baseUrl}ResetCodeEmail`, emailObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function verifyText(emailObj) {
  return apiUtils
    .post(`${baseUrl}ResetCode`, emailObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function verifyEnrollee(verifyObj) {
  return apiUtils
    .post(`${baseUrl}EnrolleeVerify`, verifyObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function validateReCaptcha(gToken) {
  return apiUtils
    .get(`${enrollmentUrl}ValidateReCaptcha?Token=` + gToken)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function resetProfilePassword(userID, password) {
  return apiUtils
    .post(`${baseUrl}ResetUserPassword`, { userID, password })
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function authenticate(UserName, password) {
  return apiUtils
    .post(`${baseUrl}authenticate`, { UserName, password })
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getStates(CountryID, BrandIdentifier) {
  let lsEnrollmentEntryType = cookies.get("lsEnrollmentEntryType");
  let enrolleeUser = cookies.get("lifesaferEnrollment");
  let enrollNow = cookies.get("EnrollNow");
  let includeTest =
    (enrolleeUser !== null &&
      enrolleeUser !== undefined &&
      enrolleeUser.isTest) ||
    (lsEnrollmentEntryType !== null &&
      lsEnrollmentEntryType !== undefined &&
      lsEnrollmentEntryType.toUpperCase() === "TEST") ||
    (enrollNow !== null && enrollNow !== undefined && enrollNow?.IsTest) ||
    false;
  return apiUtils
    .get(
      `${dateListUrl}GetStates/?portalID=${3}&countryId=${CountryID}&brandIdentifier=${
        BrandIdentifier === Monitech ? "monitechiid" : BrandIdentifier
      }&includeTest=${includeTest}`,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getCountyList(RegionId, Type, BrandIdentifier) {
  let typeAddOn = Type === undefined ? "" : "?Type=" + Type;
  let BrandIdentifierAddOn = "";
  if (BrandIdentifier !== undefined) {
    if (typeAddOn === "") {
      BrandIdentifierAddOn = "?BrandIdentifier=" + BrandIdentifier;
    } else {
      BrandIdentifierAddOn = "&BrandIdentifier=" + BrandIdentifier;
    }
  }
  return apiUtils
    .get(
      `${enrollmentUrl}GetCounties/${RegionId}${typeAddOn}${BrandIdentifierAddOn}`,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function UserVerify(userData) {
  return apiUtils
    .post(`${baseUrl}UserVerify`, userData)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function ReferralSave(referralData) {
  referralData = { ...referralData, webUserName: "PartnerForm" };
  return apiUtils
    .post(`${enrollmentUrl}ReferralSave`, referralData)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getProgramTypes(StateOfConviction, UserID) {
  return apiUtils
    .get(
      `${dateListUrl}GetProgramTypes?StateOfConviction=${StateOfConviction}&UserID=${UserID}`,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getUser(UserID) {
  return apiUtils
    .get(`${baseUrl}${UserID}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}
